import { Decoration } from '@atlaskit/editor-prosemirror/view';
import { filterDecorationByKey, SpellingAndGrammarDecorations } from '.';
export const removeSelectedSpellingDecoration = ({
  decorationSet,
  pluginState
}) => {
  return decorationSet.remove(filterDecorationByKey(SpellingAndGrammarDecorations.SPELLING_ERROR_SELECTED, decorationSet));
};
export const addSelectedSpellingDecoration = ({
  decorationSet,
  tr,
  pluginState
}) => {
  const {
    allDiffObjects
  } = pluginState;
  const {
    selection
  } = tr;
  if (allDiffObjects && selection.from === selection.to) {
    const selectedDiff = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.find(({
      from,
      to
    }) => selection.from <= to && selection.from >= from);
    if (selectedDiff) {
      const {
        from,
        to
      } = selectedDiff;
      return decorationSet.add(tr.doc, [Decoration.inline(from, to, {
        class: `ai-suggestions-selected`
      }, {
        key: `${SpellingAndGrammarDecorations.SPELLING_ERROR_SELECTED}`
      })]);
    }
  }
  return decorationSet;
};